module.exports = __webpack_public_path__ + "static/media/ico-publish.c58ea107.svg";